import { registerLocaleData } from "@angular/common";
import localeDa from "@angular/common/locales/da";
import { Injector } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

import { mdiClose } from "@mdi/js";
import "hammerjs"; // Kræves for at kunne dragge MatSlideToggle

import { filter } from "rxjs/operators";
import { first } from "rxjs/operators";

import { erstatEmailValidatorMedDffEdbUdgave } from "@dffedb/forms";
import { SvgIconRegistry } from "@dffedb/util";
import { EBoksPopupService } from "@e-forsyning/common/e-boks";
import { EforsyningMenuService } from "@e-forsyning/common/eforsyning-menu";

import { KontaktoplysningerPopupService } from "@e-forsyning/common/kontaktoplysninger-popup";
import { initUmbracoIndstillinger } from "@e-forsyning/common/umbraco-indstillinger";
import { RolleBodyClassService, RouteBodyClassService } from "@e-forsyning/common/util";
import { AktuelBrugersInstallationerService } from "@e-forsyning/common/installation/aktuel-brugers-installationer.service";

registerLocaleData(localeDa);
erstatEmailValidatorMedDffEdbUdgave();

export class AppModule {
    constructor(svgIconRegistry: SvgIconRegistry) {
        svgIconRegistry.registerIcon(mdiClose, "app-info-close", "dummy-to-trigger-build-v1");
    }
}

export function appInit(injector: Injector): () => void {
    return () => {
        console.log("[boot-debug] appInit start");
        initUmbracoIndstillinger(injector, (window as any).initUmbracoIndstillinger);
        console.log("[boot-debug] initUmbracoIndstillinger done");
        initBodyClassServices(injector);
        console.log("[boot-debug] body class services done");
        initPopups(injector);
        console.log("[boot-debug] popup subscriptions wired");
        injector.get(EforsyningMenuService).init();
        console.log("[boot-debug] menu init done");
    };
}

function initBodyClassServices(injector: Injector): void {
    injector.get(RouteBodyClassService).setup();
    injector.get(RolleBodyClassService).setup();
}

function initPopups(injector: Injector): void {
    const router = injector.get(Router);
    const eboksPopupService = injector.get(EBoksPopupService);
    const kontaktoplysningerPopupService = injector.get(KontaktoplysningerPopupService);
    const aktuelBrugersInstallationerService = injector.get(AktuelBrugersInstallationerService);

    router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(async () => {
        const installationer = await aktuelBrugersInstallationerService.select().pipe(first()).toPromise();
        if (installationer.length === 1) {
            eboksPopupService.aabnHvisIkkeAlleredeTilmeldt().then(() => {
                kontaktoplysningerPopupService.aabnHvisIkkeAlleredeTilmeldt();
            });
        }
    });
}
